import { Box, Flex, Spacer, useDisclosure } from '@chakra-ui/react'

import { FiltersButton, SearchInput } from '@/components/ui'
import { useAppSelector } from '@/redux/hooks'
import { incidentRulesFilterCountSelector } from '@/redux/ui/uiSlice'

import { RULE_SEARCH_PLACEHOLDER } from '../constants/ruleSearch'
import { RulesFilterDrawer } from '../rules-filter-drawer'

interface IProps {
  filter: string
  setFilter: (value: string) => void
}

export const RulesSearchFilterHeader = ({ filter, setFilter }: IProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const filterCount = useAppSelector(incidentRulesFilterCountSelector)

  return (
    <>
      <Box
        bgColor='white'
        borderBottom='1px solid #D5DCE4'
        boxShadow='lg'
        px='6'
        py='4'
        w='full'
      >
        <Flex
          alignItems='center'
          justifyContent='space-between'
          m='auto'
          maxW='1100px'
        >
          <Box maxW='320px' w='full'>
            <SearchInput
              dataTestId='incidentRulesPage_tableHeader_searchInput'
              onChange={(e) => setFilter(e.target.value)}
              placeholder={RULE_SEARCH_PLACEHOLDER}
              value={filter}
            />
          </Box>
          <Spacer />
          <FiltersButton
            data-testid='incidentRulesPage_tableHeader_filterButton'
            filterCount={filterCount}
            onOpen={onOpen}
          />
        </Flex>
      </Box>
      <RulesFilterDrawer isOpen={isOpen} onClose={onClose} />
    </>
  )
}
